
function scrolledCheck(){
  if(window.pageYOffset > 0){
    document.body.classList.add('window-scrolled');
  }
  else{
    document.body.classList.remove('window-scrolled');
  }
}

scrolledCheck();

window.addEventListener('scroll', scrolledCheck);


if(document.querySelector(".details-group")){

  document.querySelector(".details-group").addEventListener("click", function(event){
  
    let details = event.target.closest('details');
    let group = event.currentTarget;
  
    if(!details) return;
    if(!group.contains(details)) return;
  
    group.querySelectorAll("details").forEach(element => {
      if (element != details){
        element.removeAttribute("open");
      }
    });
  
  });
  
}

(function handleMQWidth750Change(){

  const mqWidth750 = window.matchMedia('(min-width: 750px)');
  mqWidth750.addEventListener("change", handleMQWidth750Change, { once: true });

  if(mqWidth750.matches){
    // >= 750px
    document.querySelectorAll(".footer-block details").forEach((element) => {
      element.open = true;
    });
  }
  else{
    // <= 749px
    document.querySelectorAll(".footer-block details").forEach((element) => {
      element.open = false;
    });

  }

})();




class AnimatedSprite extends HTMLImageElement {
	constructor() {
		super();

		this.previousTimeStamp = 0;
		this.movedFrameCounter = 0;

		this.frameCount = this.dataset.frameCount;

		this.addEventListener("mouseenter", function () {
			if (this.imageSpriteReverseAnimation != undefined) {
				window.cancelAnimationFrame(this.imageSpriteReverseAnimation);
			}
			this.imageSpriteForwardAnimation = window.requestAnimationFrame(
				this.imageSpriteForwardStep.bind(this)
			);
		});

		this.addEventListener("mouseleave", function () {
			if (this.imageSpriteReverseAnimation != undefined) {
				window.cancelAnimationFrame(this.imageSpriteForwardAnimation);
			}
			this.imageSpriteReverseAnimation = window.requestAnimationFrame(
				this.imageSpriteReverseStep.bind(this)
			);
		});
	}

	imageSpriteForwardStep(timestamp) {
		if (timestamp - this.previousTimeStamp > 50) {
			this.previousTimeStamp = timestamp;
			this.movedFrameCounter++;

			const singleFrameWidth = this.offsetWidth;
			const distance = this.movedFrameCounter * singleFrameWidth;

			if (this.tagName == "IMG") {
				this.style.objectPosition = `-${distance}px 0px`;
			} else {
				this.style.backgroundPosition = `-${distance}px 0px`;
			}
		}

		if (this.movedFrameCounter < this.frameCount - 1) {
			this.imageSpriteForwardAnimation = window.requestAnimationFrame(
				this.imageSpriteForwardStep.bind(this)
			);
		}
	}

	imageSpriteReverseStep(timestamp) {
		if (timestamp - this.previousTimeStamp > 50) {
			this.previousTimeStamp = timestamp;
			this.movedFrameCounter--;

			const singleFrameWidth = this.offsetWidth;
			const distance = this.movedFrameCounter * singleFrameWidth;

			if (this.tagName == "IMG") {
				this.style.objectPosition = `-${distance}px 0px`;
			} else {
				this.style.backgroundPosition = `-${distance}px 0px`;
			}
		}

		if (this.movedFrameCounter > 0) {
			this.imageSpriteReverseAnimation = window.requestAnimationFrame(
				this.imageSpriteReverseStep.bind(this)
			);
		}
	}
}

customElements.define("animated-sprite", AnimatedSprite, { extends: "img" });


function setCustomProperties(){
  document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(document.getElementById('shopify-section-header').getBoundingClientRect().bottom)}px`);
}


window.addEventListener('load', (event) => {
  setCustomProperties();
});

window.addEventListener('resize', (event) => {
  setCustomProperties();
});


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.input.onkeydown = function(e) {
     let quantity = this.value+"".concat(e.key);
      let isControlKey = (e) => e.key =='Backspace' || e.key.includes("Arrow");
      let isValideInput = (quantity)=> Number(quantity) > 0 && Number(quantity) <= 99;
      if( !isControlKey(e) && !isValideInput(quantity) ) {
        return false;
      }
    }

    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = Number(this.input.value);
    let isValideInput = ()=>  event.target.name == 'minus' || previousValue+1 > 0 && previousValue+1 <= 99;
    if(isValideInput()) {
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }else{
      console.log("invalid input");
    }
  }


}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    // if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('.customer-indicator').forEach(indicator => indicator.addEventListener('click', this.onMenuItemClick.bind(this)));

    if (
      window.location.search == '?return_url=%2Faccount' ||
      window.location.href.indexOf('/account/login') > -1 ||
      window.location.href.indexOf('/account/register') > -1
    ) {
      this.querySelectorAll('.customer-indicator').forEach(indicator => {
        indicator.classList.remove('active');
      });
    }
  }

  onMenuItemClick(event) {
    const element = event.currentTarget;
    const navGroup = document.querySelector(`[js-menu-list][data-tag="${element.dataset.tag}"]`);

    this.querySelectorAll('.customer-indicator').forEach(indicator => {
      indicator.classList.remove('active');
      if (
        !window.User?.tags.includes('professional') && 
        event.target.innerHTML.indexOf('PROFESSIONAL') >= 0 && 
        window.location.href.indexOf('/account/register') === -1
      ) {
        window.location.href = '/account/register';
      }
    });

    this.querySelectorAll('[js-menu-list]').forEach(menu => {
      menu.classList.add('hidden');
    });

    element.classList.toggle('active');


    if (!window.User?.tags.includes('professional')){
       navGroup.classList.remove('hidden');
    }else{
      this.querySelector("[js-menu-list][data-tag='professional']").classList.remove('hidden')
    }
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  // initially, this function was only dealing with opening <details>, not closing it.
  // closing function has been added, so this thing can toggle
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    if (event.target.innerHTML.indexOf('PROFESSIONAL') > -1 && !window.User?.tags.includes('professional')) {
      this.mainDetailsToggle.classList.remove('menu-opening')
      return;
    }

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (false) {
      // if(isOpen) event.preventDefault();
      if(isOpen){
        this.closeMenuDrawer(event, summaryElement);
      }
      else{
        this.openMenuDrawer(summaryElement);
      }
    } 
    else {
      if(isOpen){
        if (screen.width > 640 || !event.target.dataset.tag) {
          this.closeSubmenu(detailsElement);
        } else {
          event.target.click();
        }
      }
      else{
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);

        // only for <menu collection>
        if(detailsElement.classList.contains('Details-menu-drawer-submenu-item')){
          // <menu collection>s are occupying the same area
          // to make sure only 1 is opening, close other ones before opening the current one
          this.closeOtherSubmenus(detailsElement);
          // add opening state to <body> for outside styling
          document.body.classList.add('submenu-opening');
        }
      }
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    // this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);    
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    // this.closeAnimation(detailsElement);

    // only for <menu collection>
    if(detailsElement.classList.contains('Details-menu-drawer-submenu-item')){
      // remove opening state to <body> for styling
      document.body.classList.remove('submenu-opening');
    }

    // keep closing all opening descendant <details>s
    const openedDescendantDetailsElement = detailsElement.querySelector('details[open]');
    if(openedDescendantDetailsElement){
      this.closeSubmenu(openedDescendantDetailsElement);
      // allDetails.forEach((el) => {
      //   if(el === detailsElement) return;
      //   this.closeSubmenu(el);
      // });
    }

  }

  closeOtherSubmenus(detailsElement) {
    const allOpenedSubmenus = document.querySelectorAll('.Details-menu-drawer-submenu-item[open]');
    allOpenedSubmenus.forEach((el) => {
      if(el === detailsElement) return;
      this.closeSubmenu(el);
    });
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.header = this.header || document.getElementById('shopify-section-header');

    // document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    // document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(document.getElementById('shopify-section-header').getBoundingClientRect().bottom)}px`);
    
  }

  openMenuDrawer(summaryElement) {

    // this.header = this.header || document.getElementById('shopify-section-header');
    // this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    // document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if(this.classList.contains('slider--drag-to-scroll')){

      this.isDown = false;
      this.startX = 0;
      this.scrolled = 0;

      this.slider.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });
      
      this.slider.addEventListener('drop', (e) => {
        e.preventDefault();
      });
      
      this.slider.addEventListener('mousedown', (e) => {
        this.isDown = true;
        this.startX = e.pageX - this.slider.offsetLeft;
        this.scrolled = this.slider.scrollLeft;
      });
      this.slider.addEventListener('mouseleave', () => {
        this.isDown = false;
        this.slider.classList.remove('dragging-to-scroll');
      });
      this.slider.addEventListener('mouseup', () => {
        this.isDown = false;
        this.slider.classList.remove('dragging-to-scroll');
      });
      this.slider.addEventListener('mousemove', (e) => {
        if(!this.isDown) return;
        e.preventDefault();
        this.slider.classList.add('dragging-to-scroll');
        const x = e.pageX - this.slider.offsetLeft;
        const walk = (x - this.startX) * 1.2;
        this.slider.scrollLeft = this.scrolled - walk;
      });

    }

    if(this.classList.contains('slider--divert-scroll')){
      this.slider.addEventListener('wheel', this.onWheel.bind(this));      
    }

  }

  onWheel(event){
    if (!event.shiftKey) {

      const {top, bottom} = this.slider.getBoundingClientRect();

      if(top > 0 && bottom > 0 && top < window.innerHeight && bottom < window.innerHeight){
        
        if (event.deltaY > 0){
          if(this.slider.scrollLeft + this.slider.offsetWidth < this.slider.scrollWidth) {
            this.divertVerticalWheel(event);
          }
        }
        
        if (event.deltaY < 0){
          if(this.slider.scrollLeft > 0) {
            this.divertVerticalWheel(event);
          }
        }

      }

    }
  }

  divertVerticalWheel(event){
    event.preventDefault();
    this.slider.scrollLeft += event.deltaY * 1.5;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    if(this.sliderItemsToShow.length === 5){
      this.totalPages = this.sliderItemsToShow.length - 1;
    }
    else if(this.sliderItemsToShow.length === 3){
      this.totalPages = this.sliderItemsToShow.length;
    }
    else if(this.sliderItemsToShow.length === 8){
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
    } 
    else if(this.sliderItemsToShow.length === 12){
      if(this.getElementsByClassName('collection-feature-1')[0]){
        this.totalPages = this.sliderItemsToShow.length - 2;
        if(this.clientWidth < 768){
          this.totalPages = this.sliderItemsToShow.length;
        }
      }else{
        this.totalPages = this.sliderItemsToShow.length;
      }
    }
    else if(this.sliderItemsToShow.length === 10){
      this.totalPages = this.sliderItemsToShow.length;
    }
    else if(this.sliderItemsToShow.length === 11){
      this.totalPages = this.sliderItemsToShow.length;
    }
    else if(this.sliderItemsToShow.length === 9){
      this.totalPages = this.sliderItemsToShow.length;
    }
    else{
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    } 
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;

      this.querySelectorAll(`.slider-dot`).forEach(dot => {
        dot.classList.remove('active-dot')
      })
      this.querySelector(`.slider-dot[data-index='${this.currentPage}']`)?.classList.add('active-dot')
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    document.addEventListener('sliderComponent:play', () => this.autoRotateSlides());
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
      behavior: 'instant'
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    console.log('autoplayButtonIsSetToPlay', this.autoplayButtonIsSetToPlay)
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearTimeout(this.autoplay);
    this.autoplay = setTimeout(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearTimeout(this.autoplay);
    clearTimeout(this.clearTimout2);
    clearTimeout(this.clearTimout3);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'instant'
    });

    this.clearTimout2 = setTimeout(() => {
      clearTimeout(this.clearTimout2);
      if(this.slider.querySelector('.tabActive').classList.contains('video_background__slide')){
        this.autoplaySpeed = (this.slider.querySelector('.tabActive video').duration * 1000) - 2000;
      } else {
        this.autoplaySpeed = this.slider.dataset.speed * 1000;
      }
      clearTimeout(this.clearTimout3);
      this.clearTimout3 = setTimeout(() => {
        document.dispatchEvent(new CustomEvent('sliderComponent:play'));
        clearTimeout(this.autoplay);
      }, this.autoplaySpeed)
    }, 2000)
  }

  setSlideVisibility() {
  
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
        item.classList.add('tabActive');
      
        } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
        item.classList.remove('tabActive');
        
      }
    });
  
    if(this.slider.querySelector('.tabActive').dataset.headerColor == 'non_transparent'){
      this.slider.parentElement.classList.add('non-transparent');
      document.getElementById('shopify-section-header').classList.add('non-transparent');
    } else {
      this.slider.parentElement.classList.remove('non-transparent');
      document.getElementById('shopify-section-header').classList.remove('non-transparent');
    }
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);





/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


// slider click & drag follower

  function initCursor () {
  
    var mouseOverElements = document.querySelectorAll(".js-cursor");
    var followers = [];
  
    for (var i = 0; i < mouseOverElements.length; i++) {
      followers.push(createFollower(mouseOverElements[i]));
    }
  
    window.addEventListener("resize", invalidateFollowers);
    window.addEventListener("scroll", invalidateFollowers);
  
    function invalidateFollowers() {
      for (var i = 0; i < followers.length; i++) {
        followers[i].bounds = null;
      }
    }
  
    function createFollower(parent) {
  
      var requestId = null;
  
      var follower = parent.querySelector(".follower");
  
      var mouse = {
        bounds: null,
        x: 0,
        y: 0
      };
  
      TweenLite.set(follower, {
        xPercent: -50,
        yPercent: -50
      });
  
      parent.addEventListener("mousemove", onMouseMove);
      parent.addEventListener("mouseenter", onMouseEnter);
      parent.addEventListener("mouseleave", onMouseLeave);
      parent.addEventListener("mousedown", onMouseDown);
      parent.addEventListener("mouseup", onMouseUp);

      if (parent.classList.contains('js-has-click-targets')) {
        parent.querySelector('a').addEventListener('mouseenter', onMouseEnterAnchor);
        parent.querySelector('button').addEventListener('mouseenter', onMouseEnterAnchor);
        parent.querySelector('a').addEventListener('mouseleave', onMouseLeaveAnchor);
        parent.querySelector('button').addEventListener('mouseleave', onMouseLeaveAnchor);
      }
  
      function onMouseMove(event) {
  
        if (mouse.bounds == null) {
          mouse.bounds = parent.querySelector('.banner__media').getBoundingClientRect();
        }
        mouse.x = event.clientX - mouse.bounds.left;
        mouse.y = event.clientY - mouse.bounds.top;
        
        if(event.clientY >= mouse.bounds.bottom){
          this.classList.remove('animate');
        }
        else{
          this.classList.add('animate');
        }
          
        
        if (!requestId) {
          requestId = requestAnimationFrame(updateFollower);
        }
      }
  
      function onMouseDown () {
        this.classList.add('mousedown');
      }
  
      function onMouseUp () {
        this.classList.remove('mousedown');
      }
  
      function onMouseEnter () {
        this.classList.add('animate');
      }
  
      function onMouseLeave () {
        this.classList.remove('animate');
      }
  
      function onMouseEnterAnchor () {
        this.closest('.js-cursor').querySelector('.follower').classList.add('is-click');
      }

      function onMouseLeaveAnchor () {
        this.closest('.js-cursor').querySelector('.follower').classList.remove('is-click');
      }

      function updateFollower() {
  
        TweenLite.to(follower, 0.3, {
          x: mouse.x,
          y: mouse.y
        });
  
        requestId = null;
      }
  
      return mouse;
    }
  
  }
  
  initCursor();

  initCartSession();